import React, { useEffect, useState } from 'react';
import '../CSS file/connright.css';
import PeopleImgTitle from '../../Components/people you may know/PeopleImgTitle';
import TitleNumberFile from '../../Components/Title and number/TitleNumberFile';
import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import ImageRenderer from '../../Components/people you may know/ImageRenderer';
import { useDispatch } from 'react-redux';
import { storeUserSendInteractionWithOthers } from '../../StateManagement/slicers/userSlicer';
const people_img = require('../../assets/profile_pic.jpg');

export default function ConnectionRightSide() {
  const { tabToRender, userConnectionList } = useSelector(state => state.user);
  const [isPeopleModalOpen, setIsPeopleModelOpen] = useState(false);
  const dispatch = useDispatch();
  const [follow, setFollow] = useState([]);

  useEffect(() => {
    // if(userConnectionList.data.people_you_may_know

    // ){

    // }
    console.log('userConnectionList.data.people_you_may_know', userConnectionList?.data);
  }, [userConnectionList]);

  const peopleYouMayKnowData = userConnectionList?.data?.people_you_may_know?.slice(0, 5);

  const onPeopleViewAll = () => {
    setIsPeopleModelOpen(true);
  };

  const onPeopleViewAllCancel = () => {
    setIsPeopleModelOpen(false);
  };

  function handleFollow(e) {
    if (e.value === false || e.value === 0 || !follow.includes(e.index)) {
      dispatch(
        storeUserSendInteractionWithOthers({
          data: {
            if_requested: true,
            if_request_accepted: true,
          },
          id: e.id,
        }),
      );
      setFollow(state => [...state, e.index]);
    }
    if (e.value === true || e.value === 1 || follow.includes(e.index)) {
      let emptyArray = [];
      const indexFound = follow.indexOf(e.index);
      const currentValues = follow;
      currentValues.splice(indexFound, 1);
      currentValues.forEach(item => {
        emptyArray.push(item);
      });
      dispatch(
        storeUserSendInteractionWithOthers({
          data: {
            if_requested: false,
            if_request_accepted: false,
            if_follows: false,
          },
          id: e.id,
        }),
      );
      setFollow(emptyArray);
    }
  }

  return (
    <div className="conectin_under_right_side_contianer">
      <div className="people-you-may-know-container">
        <h6 className="people_main_title_text">People You May Know</h6>
        <div className="view-all-text" onClick={onPeopleViewAll}>
          View All
        </div>
      </div>
      <PeopleImgTitle
        valueToRender={peopleYouMayKnowData?.map(i => ({
          people_img: i?.user_personal_profile?.profile_pic || people_img,
          peopleTitle: i?.user_personal_profile?.first_name,
          peopleSubTitle: i?.role,
          peopleFirstName: i?.user_personal_profile?.first_name,
          peopleLastName: i?.user_personal_profile?.last_name,
          peopleBackupImg: people_img,
          index: i?.id,
          id: i?.id,
          value: i?.if_follows,
        }))}
      />

      <div className="dicover_by_postion_container">
        <h6 className="people_main_title_text">DISCOVER BY POSITION</h6>

        <TitleNumberFile
          valueToRender={userConnectionList?.data?.discover_by_position?.map(i => ({
            titlePostion: i?.user_personal_profile?.first_name,
          }))}
        />
      </div>

      <div className="dicover_by_postion_container">
        <h6 className="people_main_title_text">DISCOVER BY LOCATION</h6>

        <PeopleImgTitle
          valueToRender={userConnectionList?.data?.discover_by_location?.map(i => ({
            // titlePostion: i?.user_personal_profile?.first_name,
            people_img: i?.user_personal_profile?.profile_pic || people_img,
            peopleTitle: i?.user_personal_profile?.first_name,
            peopleSubTitle: i?.role,
            peopleBackupImg: people_img,
            peopleFirstName: i?.user_personal_profile?.first_name,
            peopleLastName: i?.user_personal_profile?.last_name,
          }))}
        />
        <Modal
          title="People You May Know"
          className="people-you-may-know-modal"
          open={isPeopleModalOpen}
          onCancel={onPeopleViewAllCancel}
          width={750}
          footer={null}
        >
          <div className="people-you-may-know-modal-container">
            {userConnectionList?.data?.people_you_may_know &&
              userConnectionList?.data?.people_you_may_know?.length > 0 &&
              userConnectionList?.data?.people_you_may_know?.map((item, index) => {
                return (
                  <div className="people-you-may-know-box" key={item?.role}>
                    {item?.user_personal_profile?.first_name && item?.user_personal_profile?.last_name ? (
                      <div className="people-you-may-know-image">
                        <ImageRenderer
                          firstName={item?.user_personal_profile?.first_name}
                          lastName={item?.user_personal_profile?.last_name}
                        />
                      </div>
                    ) : (
                      <img src={people_img} alt="people" className="people_img" loading="lazy" />
                    )}
                    <div className="people-you-may-know-name">
                      {item?.user_personal_profile?.first_name} {item?.user_personal_profile?.last_name}{' '}
                    </div>
                    <div className="people-you-may-know-role">{item?.role}</div>
                    <button
                      className="follow_btn"
                      onClick={() =>
                        handleFollow({
                          index: index,
                          value: item?.if_user_follow_back,
                          id: item?.id,
                        })
                      }
                    >
                      Follow
                    </button>
                  </div>
                );
              })}
          </div>
        </Modal>
      </div>
    </div>
  );
}
